export const getStatusReasonFromResponse = (response: any) => {
    return response.request?.response?.statusReason;
}